// 获取目录树
export const getGalleryDirectoryTree = ($axios) => $axios
  .get('/basecommon/v1/gallery/directory-tree')
  .then(r => r.data?.data)

// 新增目录
export const createGalleryDirectory = ($axios, data) => $axios
  .post('/basecommon/v1/gallery/directory', data)
  .then(r => r.data?.data)

// 获取文件列表
export const getGalleryFiles = ($axios, params) => $axios
  .get('/basecommon/v1/gallery/files', { params })
  .then(r => r.data?.data)

// 删除目录
export const deleteGalleryDirectory = ($axios, directoryId) => $axios
  .delete(`/basecommon/v1/gallery/directory/${directoryId}`)
  .then(r => r.data?.data)

// 更新目录（重命名等）
export const updateGalleryDirectory = ($axios, directoryId, data) => $axios
  .put(`/basecommon/v1/gallery/directory/${directoryId}`, data)
  .then(r => r.data?.data)

// 删除文件
export const deleteGalleryFile = ($axios, fileId) => $axios
  .delete(`/basecommon/v1/gallery/file/${fileId}`)
  .then(r => r.data?.data)

// 批量删除文件
export const batchDeleteGalleryFiles = ($axios, fileIds) => $axios
  .post('/basecommon/v1/gallery/files/batch-delete', { fileIds })
  .then(r => r.data?.data)

// 获取素材空间统计
export const getGalleryStats = ($axios) => $axios
  .get('/basecommon/v1/gallery/stats')
  .then(r => r.data?.data)

// 批量获取上传URL
export const batchUploadCheck = ($axios, data) => $axios
  .post('/basecommon/v1/gallery/files/batch-upload-check', data)
  .then(r => r.data?.data)

// 批量确认上传成功
export const batchConfirmUpload = ($axios, data) => $axios
  .post('/basecommon/v1/gallery/files/batch-confirm-upload', data)
  .then(r => r.data?.data)
